var map = {
	"./all_confirmed.svg": "ca12",
	"./dc.svg": "6de8",
	"./i_dc.svg": "1621",
	"./i_phd.svg": "97f1",
	"./phd.svg": "e56f",
	"./t_dc.svg": "7c24",
	"./t_phd.svg": "3479",
	"./trainee.svg": "f6d7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dbbf";